module.exports = __webpack_public_path__ + "img/pxpay.74ae71e0.png";